export enum FiltersContext {
  CreatorDatabase = "creator-database",
  Dictionary = "dictionary",
}
